import React from 'react'

import { MessagesV2 as Messages } from '@scoir/messaging'
import qs from '@scoir/query-string'
import window from 'browser-lib/window'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { UrlQueryParamTypes, addUrlProps } from 'react-url-query'

import api from 'common/api'
import withContext from 'components/RealtimeMessagingProvider/withContext'
import { actions as messagingActions } from 'store/messaging'

import './index.scss'

const DEFAULT_SORT_STR = '-Messages.SentOn'

export const onNavigateToProfile = () => {
  window.open(`${import.meta.env.BASE_URL}/settings/profile`, '_self')
}
export class MessageCenter extends React.Component {
  static propTypes = {
    userId: PropTypes.string.isRequired,
    filter: PropTypes.string,
    search: PropTypes.string,
    activeDiscussionId: PropTypes.string,
    updateUnreadMessageFlag: PropTypes.func.isRequired,
    onChangeActiveDiscussionId: PropTypes.func.isRequired,
    onChangeFilter: PropTypes.func.isRequired,
    onChangeSearch: PropTypes.func.isRequired,
    onChangeUrlQueryParams: PropTypes.func.isRequired,
    realtimeConnect: PropTypes.func.isRequired,
  }
  state = {}
  componentDidMount() {
    document.title = 'Scoir - Message Center'
  }
  loadInbox() {
    const query = qs.stringify({ search: this.props.filter, sort: DEFAULT_SORT_STR })
    return api.get(`/api/discussions?${query}`)
  }
  searchInbox() {
    const query = qs.stringify({ sort: DEFAULT_SORT_STR })
    return api.post(`/api/discussions/search?${query}`, { Search: this.props.search })
  }
  markAsRead(discussionId) {
    return api.post(`/api/discussions/${discussionId}/read`)
  }
  deleteDiscussion(discussionId) {
    return api.delete(`/api/discussions/${discussionId}`)
  }
  loadConversation(discussionId) {
    return api.get(`/api/discussions/${discussionId}/messages`)
  }
  addMessage(participantIds, msg) {
    return api.post('/api/discussions', {
      Participants: participantIds,
      Message: msg,
    })
  }
  render() {
    const ROOT = import.meta.env.BASE_URL
    return (
      <Messages
        className="messages-route"
        userId={this.props.userId}
        filter={this.props.filter}
        search={this.props.search}
        activeDiscussionId={this.props.activeDiscussionId}
        updateUnreadMessageFlag={this.props.updateUnreadMessageFlag}
        onChangeActiveDiscussionId={this.props.onChangeActiveDiscussionId}
        onDiscussionFiltersChange={(filter, search) => this.props.onChangeUrlQueryParams({ filter, search })}
        onLoadInbox={() => this.loadInbox()}
        onSearchInbox={() => this.searchInbox()}
        onMarkAsRead={(msgId) => this.markAsRead(msgId)}
        onLoadConversation={(convoId) => this.loadConversation(convoId)}
        onDeleteDiscussion={(convoId) => this.deleteDiscussion(convoId)}
        onAddMessage={(participants, msg) => this.addMessage(participants, msg)}
        emptyConversationComponent={
          <div className="empty-message">
            No Conversation Here
            <br />
            <small>Find a high school on the map and start talking!</small>
          </div>
        }
        messagesPath={`${ROOT}/message-center/messages`}
        notificationsPath={`${ROOT}/message-center/notifications`}
        onSendError={() => this.setState({ errorMessage: 'Message could not be delivered.' })}
        errorMessage={this.state.errorMessage}
        realtimeConnect={this.props.realtimeConnect}
        onNavigateToProfile={onNavigateToProfile}
      />
    )
  }
}

export const ConnectedMessageCenter = connect(
  (state) => ({
    userId: state.user.record.Id,
  }),
  {
    updateUnreadMessageFlag: messagingActions.updateUnreadMessageFlag,
  },
)(MessageCenter)

const urlPropsQueryConfig = {
  filter: { type: UrlQueryParamTypes.string },
  search: { type: UrlQueryParamTypes.string },
  activeDiscussionId: { type: UrlQueryParamTypes.string },
}

const RealtimeMessagingConnected = withContext({
  connect: 'realtimeConnect',
})(ConnectedMessageCenter)

export default addUrlProps({ urlPropsQueryConfig, addUrlChangeHandlers: true })(RealtimeMessagingConnected)
